import { getField } from 'vuex-map-fields';
import {
  isEmpty, flatten, isArray, map, intersection,
} from 'lodash';
import { getIncludedData, getIncludedDataFor, getAssociatedList } from './helpers';

const filterByRelationship = (courses, value, filter) => {
  if (isEmpty(value)) {
    return courses;
  }
  return courses.filter(
    (course) => {
      if (isArray(course.relationships[filter].data)) {
        return !isEmpty(intersection(flatten([value]), map(course.relationships[filter].data, 'id')));
      }
      return flatten([value]).includes(course.relationships[filter].data.id);
    },
  );
};

const filterByAvailability = (courses, value) => {
  if (value === '2') {
    return courses.filter((course) => course.attributes.remaining_spots > 0);
  }
  if (value === '3') {
    return courses.filter((course) => course.attributes.remaining_spots <= 0);
  }
  return courses;
};

const filterCourses = (courses, filters) => {
  let filteredCourses = filterByRelationship(courses, filters.sport, 'sport');
  filteredCourses = filterByRelationship(filteredCourses, filters.campus, 'campuses');
  filteredCourses = filterByAvailability(filteredCourses, filters.availability);
  return filteredCourses;
};

const getters = {
  courseList: (state) => {
    let courses = state.courses.data || [];
    courses = filterCourses(courses, state.filters);
    return courses.map((course) => ({
      ...course,
      sport: getIncludedDataFor(course, state.courses, 'sport'),
      campuses: getAssociatedList(course, state.courses, 'campuses'),
      teacher: getIncludedDataFor(course, state.courses, 'teacher'),
    }));
  },

  subscriptionList: (state) => {
    const subscriptions = state.subscriptions.data || [];
    return subscriptions.map((subscription) => ({
      ...subscription,
      sport: getIncludedDataFor(subscription, state.subscriptions, 'sport'),
      campuses: getAssociatedList(subscription, state.subscriptions, 'campuses'),
      teacher: getIncludedDataFor(subscription, state.subscriptions, 'teacher'),
      course: getIncludedDataFor(subscription, state.subscriptions, 'course'),
    }));
  },

  courseSport: (state) => getIncludedData(state.course, 'sport'),
  courseCampuses: (state) => getAssociatedList(state.course.data, state.course, 'campuses'),
  courseTeacher: (state) => getIncludedData(state.course, 'teacher'),
  coursePrograms: (state) => getAssociatedList(state.course.data, state.course, 'course_programs'),
  subscriptionCourse: (state) => getIncludedData(state.subscription, 'course'),
  subscriptionSport: (state) => getIncludedData(state.subscription, 'sport'),
  subscriptionCampuses: (state) => getAssociatedList(state.subscription.data, state.subscription, 'campuses'),
  subscriptionTeacher: (state) => getIncludedData(state.subscription, 'teacher'),
  isSubscriptionPending: (state) => !isEmpty(state.pendingSubscription),
  getField,
};

export default getters;
